import React, {
  Component,
  Fragment
} from 'react';
import _ from 'lodash';

import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as JSZip from 'jszip';

import FilterDropdown from './FilterDropdown';

import { removeVisibilityFilter } from '../../actions/DataDefaultActions';


export class FiltersComponent extends Component {

  static propTypes = {
    dispatch: PropTypes.any,
    newSongs: PropTypes.object,
    items: PropTypes.array
  };
  setActiveFilters() {
    return this.props.activeFilter.selected.map((fil, i) => (
      <div className="control" key={`filter_${i}`}>
        <div className="tags has-addons" >
          <span className="tag is-dark">{fil.type}: {fil.filter.name}</span>
          <span className="tag is-delete" style={{ cursor: 'pointer' }} onClick={() => this.props.removeVisibilityFilter(fil)}></span>
        </div>
      </div>
    ));
  }
  render() {
    return (
      <Fragment>
        <section className="field">
          <section>
            <FilterDropdown name="Category" items={this.props.categories.items.category} type="genre" />
            <FilterDropdown name="Mood/Style" items={this.props.categories.items.mood} type="mood" />
            <FilterDropdown name="Energy" items={this.props.categories.items.energy} type="energy" />
            <FilterDropdown name="Instrument" items={this.props.categories.items.instrument} type="instrument" />
          </section>

        </section>
        <section className="field">
          {(this.props.activeFilter.selected.length > 0) && <p className="is-inline-block has-text-white">Filtering by:</p>}
          
        </section>
        <div className="field is-grouped is-grouped-multiline">
          {this.setActiveFilters()}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps({ categories }) {
  return {
    categories
  }
}



function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeVisibilityFilter }, dispatch);
}

export const Filters = connect(mapStateToProps, mapDispatchToProps)(FiltersComponent);


// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js